import { OrganisationService } from '../../service/organisation/organisation.service';
import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of, switchMap, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
    selector: '[uflaUniqueName]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: UniqueNameDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class UniqueNameDirective {
    private organisationService = inject(OrganisationService);


  @Input() uflaUniqueName: string;

  validate(nameControl: AbstractControl): Observable<ValidationErrors | null> {
      {
          if (!nameControl.value || this.uflaUniqueName === nameControl.value) {
              return of(null);
          }

          return timer(500).pipe(
              switchMap(() => this.organisationService.existsOrgWithName(nameControl.value)),
              map(
                  nb => {
                      return nb ? { uniqueNetzbetreiberName: true } : null;
                  },
              ),
          );
      }
  }
}
